import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import SmsTemplateBasicDetail from "./components/SmsTemplateBasicDetail";

import { useGetSmsTemplateDetailQuery } from "store/services/smsTemplateApi";

import {
  SmsTemplateDetailContext,
  useSmsTemplateDetailContext,
} from "contexts/SmsTemplateDetailContext";
import SmsTemplateDetailTab from "./components/SmsTemplateDetailTab";

const SmsTemplateDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "SMS Templates", path: "/app/crm/sms-templates/list" },
    { title: "SMS Template Detail" },
  ];

  // RTK Query
  const {
    data: smsTemplateDetail,
    isLoading: loadingSmsTemplate,
    error,
  } = useGetSmsTemplateDetailQuery(id);

  return (
    <SmsTemplateDetailContext.Provider
      value={{ smsTemplateDetail, loadingSmsTemplate }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingSmsTemplate}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <SmsTemplateBasicDetail />
          <Divider />
          <SmsTemplateDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </SmsTemplateDetailContext.Provider>
  );
};

export default SmsTemplateDetailScreen;

const PageActions = () => {
  const { smsTemplateDetail } = useSmsTemplateDetailContext();
  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/sms-templates/${smsTemplateDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};